export default __webpack_public_path__ + "static/media/logo_fairstone_bi_card_reversed.88697cc8.svg";